export const SAVED = (state, saving) => {
  state.saved = saving
}
export const LOADING = (state, loading) => {
  state.loading = loading
}
export const REDIRECT = (state, redirect) => {
  state.redirect = redirect
}
